/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
export function subtract(a, b) {
	return a - b;
}

export const sub = subtract;
